import React from 'react';
import { isHeroImageV0 } from '@bbkAdminComponents/experiences/migrations/offers';
import { type RestFortySixtyMiniModal2Modal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import ModalPerson from './sections/person';
import SimpleModalTitle from './sections/simple-title';

type Props = Pick<
  RestFortySixtyMiniModal2Modal['requires'],
  'info' | 'person' | 'hero'
> & {
  actions: React.ReactNode;
};

const NoteModal2: React.FC<Props> = (props) => {
  const { info, person, hero, actions } = props;

  const renderSidebar = () => {
    if (person) {
      return <ModalPerson person={person} />;
    }
    if (hero) {
      if (isHeroImageV0(hero)) {
        return <img src={hero.img} alt="" className="hero-image" />;
      }
      return <img src={hero.url} alt="" className="hero-image" />;
    }
    return null;
  };

  return (
    <div className="forty-sixty-mini-modal-2 forty-sixty-mini-modal">
      <div className="MMContainer">
        <div className="left">{renderSidebar()}</div>
        <div className="right">
          <div className="wrap">
            <SimpleModalTitle>
              <CustomerHtml value={info.title} />
            </SimpleModalTitle>
            <div className="note">
              <div className="details">
                <CustomerHtml value={info.details} />
              </div>
            </div>
            <div className="action">{actions}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteModal2;
